// The Admin configuration console's routes and its five list areas (lane B10 S20a; plan D14; CR-066). Loaded by
// views/b10/register.ts. `#settings` lands on the console (the Admin) or goes on to the permission matrix (any other
// reader the route admits); `#settings/config/<area>[/<name>]` is the console, gated on `config.list` (*Business
// configuration*). S20b registers Thresholds (40), Reminders (50) and Templates (60) into the same rail from
// views/b10/system/register.ts.

import { G6_LABELS } from "@/mc";
import { registerView } from "../shell";
import { registerConsoleArea } from "./areas";
import { ListArea } from "./AreaTable";
import { Console, SettingsLanding } from "./Console";
import { CONSOLE_LABELS } from "./labels";

registerView(/^settings\/?$/, SettingsLanding, { lane: "B10", gates: ["config.list", "permissions.matrix"] });
registerView(/^settings\/config(?:\/[a-z0-9_.-]+){0,2}$/, Console, { lane: "B10", specificity: 1, gates: ["config.list"] });

// D14's rail: Statuses · Reason lists · Taxonomies · (Thresholds · Reminders · Templates, S20b) · Segments · Strategies.
// Segments and Strategies are taxonomies B1 registered (`taxonomies:segment`, `taxonomies:posting_strategy`); naming the
// exact keys takes them out of Taxonomies. Reporting category and Decline reasons are named so their first version can
// be proposed before any lane seeds one.
registerConsoleArea({ key: "statuses", label: G6_LABELS.statuses, order: 10, kinds: ["status_labels"], Editor: ListArea });
registerConsoleArea({
  key: "reason_lists",
  label: G6_LABELS.reasonLists,
  order: 20,
  kinds: ["reasons", "reasons:cancel_category", "reasons:offer_decline"],
  Editor: ListArea,
});
registerConsoleArea({ key: "taxonomies", label: CONSOLE_LABELS.taxonomies, order: 30, kinds: ["taxonomies"], Editor: ListArea });
registerConsoleArea({ key: "segments", label: CONSOLE_LABELS.segments, order: 70, kinds: ["taxonomies:segment"], Editor: ListArea });
registerConsoleArea({ key: "strategies", label: CONSOLE_LABELS.strategies, order: 80, kinds: ["taxonomies:posting_strategy"], Editor: ListArea });
